import React from 'react'

function ID2() {
    return (
        <div>
            <p>
                Прикладное решение "Зарплата и управление персоналом КОРП для Казахстана" ориентировано на средние и крупные предприятия и предназначено
                для автоматизации системы управления персоналом, кадрового учета и расчета заработной платы по перечисленным далее направлениям.
            </p>
            <p></p>
            <p>
                <h4>Реализация политики компании в области управления персоналом:</h4>
            </p>
            <ul>
                <li>планирование потребностей в персонале,</li>
                <li>поиск и отбор кандидатов, размещение вакансий на популярных интернет-сайтах и загрузка резюме кандидатов по заданным требованиям,</li>
                <li>планирование и учет расходов на персонал по проектам и направлениям деятельности,</li>
                <li>поддержка процедур адаптации и увольнения, планирование и контроль выполнения мероприятий, связанных с перемещением сотрудника,</li>
                <li>оценка персонала,</li>
                <li>обучение и развитие,</li>
                <li>формирование кадрового резерва и управление талантами,</li>
                <li>финансовая мотивация: создание гибких схем денежного вознаграждения,</li>
                <li>управление социальными льготами,</li>
                <li>самообслуживание сотрудников: самостоятельное получение сведений о своей зарплате, остатках отпусков, предлагаемых льготах,</li>
                <li>планирование занятости персонала,</li>
                <li>поддержка грейдов.</li>
            </ul>
            <p>
                <h4>2. Реализация регламентированных процедур работы с персоналом:</h4>
            </p>
            <ul>
                <li>охрана труда,</li>
                <li>учет кадров и анализ кадрового состава,</li>
                <li>аттестация,</li>
                <li>трудовые отношения, в том числе кадровое делопроизводство,</li>
                <li>расчет заработной платы персонала,</li>
                <li>управление денежными расчетами с персоналом, включая депонирование,</li>
                <li>исчисление регламентированных законодательством налогов и взносов с фонда оплаты труда,</li>
                <li>отражение начисленной зарплаты и налогов в затратах предприятия.</li>
            </ul>
            <p>
                <h4>Ведение учета деятельности нескольких организаций</h4>
            </p>
            <p>
                Конфигурация позволяет вести управленческую и учетную деятельность от имени нескольких организаций (которые могут быть оформлены как юридические
                лица или являться частными предпринимателями). При этом каждая организация может вести учет по общей или упрощенной системе налогообложения в
                рамках одной и той же информационной базы.
            </p>
            <p>
                Конфигурация также может использоваться на предприятиях холдинговой структуры, состоящих из нескольких организаций, которые оформлены как
                юридические лица или являются индивидуальными предпринимателями. Программа обеспечивает параллельное ведение двух видов учета персонала –
                управленческого и регламентированного. Управленческий учет ведется по компании в целом, а регламентированный учет ведется отдельно для каждой
                организации (юридического лица или индивидуального предпринимателя).
            </p>
            <p>
                <h4>Автоматизация управления персоналом</h4>
            </p>
            <p>
                В конфигурации реализованы все основные направления автоматизации управления персоналом крупного предприятия: подбор, адаптация, мотивация,
                обучение, оценка, управление талантами, кадровый резерв, управление расходами на персонал, проведение аттестаций, поддержка грейдов, управление
                социальными льготами, анкетирование. Большинство механизмов снабжены рабочими местами – специальными формами, объединяющими необходимый
                функционал для выполнения отдельных бизнес-процессов. С учетом особенностей системы управления персоналом в крупных компаниях реализована
                поддержка процессов "заявка – согласование – утверждение".
            </p>
            <p>
                <h4>Планирование потребностей в кадрах</h4>
            </p>
            <p>
                Планирование потребностей в человеческих ресурсах осуществляется в кадровом плане. Исходные данные для планирования могут поступать из
                производственных систем. Кадровый план позволяет запланировать организационно-должностной состав, событийный план изменений
                организационно-должностного состава, фонд затрат на оплату труда. При помощи отчетов по состоянию кадрового плана можно получить оценку
                эффективности работ по набору сотрудников, количество вакантных рабочих мест и данные о планируемых расходах на персонал.
            </p>
            <p>
                <h4>Взаимодействие с интернет-сайтами для поиска кандидатов</h4>
            </p>
            <p>
                Система позволяет взаимодействовать с популярными интернет-сайтами: выгружать в интернет сведения об имеющихся в компании вакансиях и получать
                данные резюме кандидатов, удовлетворяющих заданным условиям.
            </p>
            <p>
                <h4>Автоматизация подбора персонала</h4>
            </p>
            <p>
                Подсистема подбора персонала предназначена для документирования и автоматизации процесса подбора и оценки кандидатов. Подсистема обеспечивает
                хранение личных данных о кандидатах как о физических лицах; хранение материалов, появляющихся в процессе работы с кандидатом, начиная от резюме
                и до результатов анкетирования; подготовку встреч с кандидатами и регистрацию принятых решений вплоть до принятия на работу. Основной инструмент
                системы – автоматизированное рабочее место менеджера по персоналу, при помощи которого можно осуществлять все этапы работ по заполнению
                вакантных рабочих мест.
            </p>
            <p>
                <h4>Грейды</h4>
            </p>
            <p>
                Поддержка оценки должностей по степени важности для компании. Позволяет присвоить каждой должности уровень и сгруппировать таким образом
                должности по значимости. Использование грейдов в системе является опциональным. Грейд может определять схему мотивации и пакет льгот для группы
                должностей.
            </p>
            <p>
                <h4>Адаптация и увольнение</h4>
            </p>
            <p>
                Механизм позволяет определить последовательность и состав мероприятий, выполняемых при вступлении в должность и освобождении должности
                сотрудником. Мероприятия могут быть заданы как для сотрудников всех позиций компании, так и для отдельных подразделений, должностей или рабочих
                мест. При создании кадрового события (прием, перемещение или увольнение) система формирует исполнителям задачи для выполнения мероприятий,
                связанных с адаптацией, перемещением или увольнением сотрудников. Ответственное лицо имеет возможность контролировать выполнение задач.
            </p>
            <p>
                <h4>Мотивация и управление льготами</h4>
            </p>
            <p>
                Подсистема позволяет разрабатывать и применять схемы финансовой мотивации сотрудников с использованием различных показателей эффективности
                деятельности (KPI) как отдельного сотрудника, так и компании в целом. При разработке схем мотивации может быть использовано произвольное
                количество видов начислений. При этом имеется возможность конструировать сам алгоритм расчета начисления на базе широкого спектра математических
                формул с участием используемых в компании показателей эффективности деятельности (KPI).
            </p>
            <p>
                В целях предварительной оценки новой схемы мотивации имеется возможность параллельно рассчитать зарплату по нескольким схемам мотивации, а
                затем, сравнив полученные результаты, выбрать оптимальную. В конфигурацию включены средства для импорта данных о текущих значениях показателей
                эффективности (KPI) сотрудников из программы "1С:Управление торговлей 8".
            </p>
            <p>
                Реализована поддержка проектирования и создания пакета социальных льгот для позиций компании или грейдов, планирование и учет расходов на
                предоставление льгот, анализ использования предоставленных льгот сотрудниками.
            </p>
            <p>Схемы мотивации и пакеты льгот определяются для сотрудников различных должностей или грейдов.</p>
            <p>
                <h4>Проектный учет затрат и учет затрат по направлениям деятельности</h4>
            </p>
            <p>Подсистема расширяет возможности планирования и учета расходов на персонал. Ее использование позволяет:</p>
            <ul>
                <li>получать данные о распределении расходов на персонал по проектам и направлениям деятельности компании;</li>
                <li>планировать (составлять бюджет) расходов на персонал, анализировать соответствие фактических расходов плановым.</li>
            </ul>
            <p>
                Используя данные сотрудников об отработанном времени, на основе гибкой системы настройки статей расходов и аналитики выполняется распределение
                расходов по объектам деятельности. Учитываются расходы на зарплату, налоги и взносы, социальные льготы и компенсации, обучение, оформление
                допусков на работу, медицинские осмотры. Объектами деятельности могут быть объекты различных типов: подразделения, направления деятельности,
                проекты и др. Система подготавливает сведения для передачи во внешнюю систему анализа, а также выполняет независимое распределение расходов
                только на основе данных о расходах на персонал.
            </p>
            <p>
                Руководители подразделений, ответственные за направления, и руководители проектов получают возможность влиять на объем списываемых на их объекты
                расходов. При помощи инструмента "Управление расходами на персонал" они могут отклонить расходы, которые, по их мнению, не имеют отношения к
                выполняемой по объекту деятельности.
            </p>
            <p>
                <h4>Рабочее место самообслуживания сотрудников</h4>
            </p>
            <p>
                Функционал позволяет сотруднику получить сведения о себе и своей деятельности в компании. Механизм призван снизить нагрузку на службу персонала
                за счет обеспечения сотрудников всей необходимой информацией и автоматизацией взаимодействия с ним.
            </p>
            <p>
                <h4>Рабочее место сотрудника предоставляет возможности:</h4>
            </p>
            <ul>
                <li>просматривать сведения о себе и подавать заявку на их изменение;</li>
                <li>просматривать остатки отпусков и подавать заявку на отпуск;</li>
                <li>просматривать сведения о начисленной зарплате;</li>
                <li>просматривать сведения о доступных льготах и выбирать льготы в пределах установленного лимита;</li>
                <li>регистрировать планируемое отсутствие;</li>
                <li>отвечать на вопросы анкеты.</li>
            </ul>
            <p>
                <h4>Кадровый резерв</h4>
            </p>
            <p>
                Поддержка создания и ведения кадрового резерва. Кадровый резерв позволяет, с одной стороны, минимизировать потери, связанные с уходом ключевого
                сотрудника, а с другой стороны – для каждого перспективного сотрудника запланировать его развитие. Механизм предоставляет возможности:
            </p>
            <ul>
                <li>создавать резерв на ключевую позицию и описывать требования к кандидатам в резерв;</li>
                <li>формировать состав резерва из сотрудников компании, кандидатов, других физических лиц (например, сотрудников компаний-конкурентов);</li>
                <li>проводить анализ кадровых перестановок "что если" на основе данных кадрового резерва;</li>
                <li>создавать и управлять Talent pool (фондом талантов).</li>
            </ul>
            <p>
                <h4>Обучение и развитие персонала</h4>
            </p>
            <p>Управление обучением и развитием персонала включает в себя возможности:</p>
            <ul>
                <li>создавать руководителями подразделений заявки на обучение по определенным курсам или развивать заданные компетенции;</li>
                <li>формировать потребности в обучении сотрудников компании;</li>
                <li>подготавливать план по обучению;</li>
                <li>регистрировать результаты обучения;</li>
                <li>учитывать расходы на проведение обучающих мероприятий;</li>
                <li>вести отчетность по динамике изменения компетенций сотрудников.</li>
            </ul>
            <p>
                <h4>Аттестация персонала</h4>
            </p>
            <p>
                Обеспечивает возможность организовать систему аттестации в компании, автоматизировать отдельные операции проведения аттестации, обеспечить учет
                результатов аттестации. В рамках подсистемы реализовано:
            </p>
            <ul>
                <li>создание положения об аттестации;</li>
                <li>создание приказа о проведении аттестации;</li>
                <li>формирование аттестационной комиссии, графика аттестации и аттестационных листов;</li>
                <li>учет результатов аттестации и решений аттестационной комиссии;</li>
                <li>анализ сведений об аттестации.</li>
            </ul>
            <p>
                <h4>Допуски к работам</h4>
            </p>
            <p>
                Для выполнения отдельных видов работ часто необходимо оформление особого права – допуска к работам. Например, лицензии на ношение оружия для
                охранников, водительского удостоверения для водителя, допуск к работам на высоте для монтажников. В системе предусмотрены возможности:
            </p>
            <ul>
                <li>определять виды допусков, а также должности, для работы на которых необходим допуск, и сроки действия допусков;</li>
                <li>регистрировать факты получения допусков;</li>
                <li>фиксировать расходы компании на оформление допусков к работам;</li>
                <li>оформлять приказы о допуске к работам и об отстранении от работы в связи с отсутствием допуска;</li>
                <li>
                    анализировать наличие допусков к работам у сотрудников, отсутствие обязательных допусков, сроки действия допусков, выделять "просроченные"
                    допуски.
                </li>
            </ul>
            <p>
                <h4>Учет медицинских осмотров</h4>
            </p>
            <p>
                Механизм позволяет вести учет различных видов медицинских осмотров, планировать и оформлять графики проведения медосмотров, регистрировать в
                системе результаты осмотров, формировать отчетность по данным медицинских осмотров, отражать в системе расходы на проведение медицинских
                осмотров, контролировать прохождение обязательных медицинских осмотров для отдельных категорий сотрудников.
            </p>
            <p>
                <h4>Инструктажи по охране труда</h4>
            </p>
            <p>Функциональность позволяет вести учет таких плановых мероприятий по охране труда, как инструктажи по охране труда:</p>
            <ul>
                <li>учет различных видов инструктажей по охране труда;</li>
                <li>оформление журнала учета инструктажей;</li>
                <li>контроль сроков проведения инструктажей.</li>
            </ul>
            <p>
                <h4>Учет несчастных случаев на производстве</h4>
            </p>
            <p>Поддержка учета несчастных случаев на производстве и их расследования обладает возможностями:</p>
            <ul>
                <li>регистрировать факт несчастного случая;</li>
                <li>формировать весь предусмотренный законодательством пакет документов по расследованию несчастного случая;</li>
                <li>вести учет ущерба, понесенного в результате несчастного случая;</li>
                <li>анализировать статистику несчастных случаев по причинам их возникновения.</li>
            </ul>
            <p>
                <h4>Веб-анкетирование</h4>
            </p>
            <p>
                Подсистема предназначена для составления анкет, проведения опросов и анализа результатов опросов. С помощью веб-клиента можно проводить опросы
                через Интернет. Авторизовавшийся респондент получает доступ к предназначенным для него опросам, а также к архиву ранее заполненных им анкет.
                Подсистема предоставляет ряд отчетов, которые позволяют анализировать в различных разрезах результаты одного выбранного опроса и сравнивать
                результаты, полученные при проведении нескольких опросов.
            </p>
            <p>
                <h4>Планирование занятости персонала</h4>
            </p>
            <p>
                Подсистема планирования занятости позволяет планировать встречи сотрудников компании, в том числе и со сторонними лицами, и проведение
                мероприятий. Кроме того, поддерживается планирование очередных отпусков сотрудников с использованием системы утверждения принятых решений.
            </p>
            <p>
                <h4>Инструменты руководителя</h4>
            </p>
            <p>
                <h4>Управление начислениями</h4>
            </p>
            <p>
                Инструмент предназначен для просмотра и изменения значений показателей расчета заработной платы (без привязки к видам расчета). Просмотр
                значений показателей осуществляется в удобной, настраиваемой форме, по всем сотрудникам подразделения или компании с указанием прежнего значения
                и размера предлагаемого изменения. Для целей анализа предусмотрены отчеты сравнения показателей нескольких сотрудников и детализации сведений об
                истории показателей отдельного сотрудника. Форма поддерживает выгрузку показателей в документ Microsoft Excel и загрузки измененных значений.
                Для отражения изменений значений показателей система самостоятельно подбирает соответствующие документы и заполняет их.
            </p>
            <p>
                Рабочее место по управлению начислениями служит средством взаимодействия руководителя подразделения и руководителя компании по вопросам
                зарплаты. Руководители подразделения вводят предлагаемые изменения значений показателей и комментируют предложения. Руководитель компании,
                просматривая форму, отличает предлагаемые изменения, утверждает или отклоняет их, самостоятельно назначает разовые и изменяет плановые
                начисления.
            </p>
            <p>
                <h4>Монитор руководителя</h4>
            </p>
            <p>
                Панель наиболее важных и срочных показателей системы управления персоналом компании в сжатом информативном виде. Позволяет оценить текущее
                состояние, сравнить его с состоянием прошлого периода, проанализировать динамику изменений, быстро получить более подробные отчеты. Монитор
                содержит показатели:
            </p>
            <ul>
                <li>сведения о начисленной заработной плате и налогах;</li>
                <li>состояние взаиморасчетов с сотрудниками;</li>
                <li>количество открытых вакансий;</li>
                <li>информацию о численности персонала;</li>
                <li>потери рабочего времени;</li>
                <li>расходы на персонал;</li>
                <li>ближайшие кадровые события: уход в отпуск и отъезд в командировку ключевых сотрудников;</li>
                <li>динамику изменения отдельных показателей за 12 месяцев (диаграммы).</li>
            </ul>
            <p>
                <h4>Учет кадров и анализ кадрового состава</h4>
            </p>
            <p>
                Подсистема кадрового учета предполагает хранение не только личных данных о сотрудниках компании, но и служебной информации. К последней
                относятся: подразделение, где работает сотрудник, его должность, количество занимаемых ставок, служебные телефоны и прочая контактная
                информация. Регистрируется и продвижение сотрудника в компании: его прием на работу, служебные перемещения, командировки – вплоть до увольнения.
                Также поддерживается учет отпусков и контроль фактического использования отпусков, составление отчетов по выполнению графика отпусков.
            </p>
            <p>
                По накопленной информации можно построить разнообразные отчеты, которые обеспечивают исходные данные для проведения анализа кадрового состава,
                причин текучести кадров и т. п. Отчеты предоставляют пользователям широкие возможности настройки объема и подробности выводимых сведений, а
                также просмотра и анализа информации в графическом виде – в виде диаграмм и сводных таблиц.
            </p>
            <p>
                Подсистема регламентированного кадрового учета позволяет автоматизировать трудоемкие рутинные операции, высвободить сотрудников для выполнения
                собственно аналитических и управленческих функций и тем самым повысить эффективность службы управления персоналом. Подсистема включает в себя
                средства для ведения учета по следующим направлениям:
            </p>
            <ul>
                <li>трудовые отношения, кадровое делопроизводство;</li>
                <li>воинский учет.</li>
            </ul>
            <p>
                <h4>Трудовые отношения, кадровое делопроизводство</h4>
            </p>
            <p>
                Решение "Зарплата и управление персоналом КОРП для Казахстана" поддерживает ведение штатного расписания организаций с возможностью указания
                различных видов тарифных ставок, произвольного количества надбавок и дополнительной информации о штатных единицах.
            </p>
            <p>По штатному расписанию формируется вся необходимая отчетность, в том числе представление штатного расписания в виде печатной формы.</p>
            <p>
                В программе автоматизировано кадровое делопроизводство, включая заполнение печатных форм: оформление трудовых договоров, прием на работу,
                кадровые перемещения сотрудников, увольнение из организации.
            </p>
            <p>
                На основании кадровых данных строится унифицированная форма Т-2, содержащая в том числе сведения о непрерывном и общем стаже сотрудников
                предприятия.
            </p>
            <p>
                В соответствии с утвержденным графиком отпусков предприятия заполняется печатная форма "График отпусков" и формируются приказы о предоставлении
                отпуска сотрудникам.
            </p>
            <p>
                Запланированные командировки сотрудников регистрируются, при этом подготавливаются приказы о направлении сотрудников в командировку, заполняются
                командировочные удостоверения. 
            </p>
            <p>
                <h4>Воинский учет</h4>
            </p>
            <p>
                Ведение воинского учета в конфигурации организовано в соответствии со Правилами воинского учета военнообязанных и призывников (утв. Приказом
                Министра обороны Республики Казахстан от 24 января 2017 года № 28. Зарегистрирован в Министерстве юстиции Республики Казахстан 10 марта 2017
                года № 14881).
            </p>
            <p>
                В конфигурацию включены следующие отчеты, которые представляются организациями по запросам военкоматов либо на регулярной основе: "Данные для
                постановки на учет в военкомате"; "Численность граждан запаса"; "Список граждан, подлежащих постановке на воинский учет"; "Список принятых и
                уволенных военнообязанных"; "Список юношей 15–16 лет"; "Список для первоначальной постановки юношей на воинский учет"; "Список принятых и
                уволенных призывников".
            </p>
            <p>
                <h4>Расчет и учет заработной платы</h4>
            </p>
            <p>
                Для расчета и учета заработной платы в программе автоматизирована деятельность как менеджеров, принимающих решения по заработной плате
                персонала, так и бухгалтеров-расчетчиков заработной платы:
            </p>
            <ul>
                <li>разработка и анализ схем мотивации сотрудников;</li>
                <li>учет результатов производственной деятельности;</li>
                <li>автоматический расчет широкого круга начислений – от оплаты по окладу до оплаты больничных и отпусков по среднему заработку;</li>
                <li>гибкая настройка используемых начислений и удержаний.</li>
            </ul>
            <p>
                Конфигурация обеспечивает ведение взаиморасчетов с сотрудниками, а также учет затрат на оплату труда в составе себестоимости продукции и услуг.
                Автоматизирован весь комплекс расчетов с персоналом, начиная от ввода документов о фактической выработке и фактическом использовании рабочего
                времени, оплаты больничных листов и отпусков вплоть до формирования документов на выплату зарплаты и депонирование, а также отчетности в
                государственные надзорные органы.
            </p>
            <p>
                Реализованы основные формы оплаты труда, используемые на хозрасчетных предприятиях: повременная (с использованием месячных, дневных и почасовых
                тарифных ставок) и сдельная формы оплаты труда, а также их варианты – повременно-премиальная и сдельно-премиальная формы оплаты труда.
            </p>
            <p>
                Гибкий механизм учета использования рабочего времени позволяет, с одной стороны, описывать различные графики работы и регистрировать только
                отклонения от обычного режима работы, а с другой – регистрировать только фактические данные об использовании рабочего времени на основе
                заполняемых в подразделениях табелей.
            </p>
            <p>
                В целях обеспечения работы на предприятиях с большим количеством сотрудников основные "расчетные" документы снабжены средствами автоматического
                заполнения и расчета.
            </p>
            <p>
                Помимо проведения массовых расчетов заработной платы программа подготавливает все необходимые унифицированные формы по учету труда и заработной
                платы и другие необходимые отчеты, позволяющие получить информацию за любой расчетный период:
            </p>
            <ul>
                <li>расчетные листки,</li>
                <li>расчетно-платежные ведомости,</li>
                <li>платежные ведомости для получения денег через кассу,</li>
                <li>расходные кассовые ордера,</li>
                <li>свод по начислениям и удержаниям и т. д.</li>
            </ul>
            <p>Результаты расчетов могут быть представлены в виде аналитических отчетов, наглядных графиков и диаграмм:</p>
            <ul>
                <li>анализ начислений работников организаций,</li>
                <li>анализ взаиморасчетов с сотрудниками организаций и др. </li>
            </ul>
            <p>
                <h4>Исчисление регламентированных налогов</h4>
            </p>
            <p>
                Подсистема обеспечивает исчисление регламентированных законодательством налогов с фонда оплаты труда: индивидуальный подоходный налог,
                социальный налог, обязательные пенсионные взносы и социальные отчисления. Исчисление социального налога и социальных отчислений поддерживается
                для всех режимов налогообложения доходов организаций, включая специальные налоговые режимы.
            </p>
            <p>
                <h4>Отражение в регламентированном учете начисленных сумм заработной платы, налогов, взносов и отчислений</h4>
            </p>
            <p>
                Гибкая реализация учета начисленной зарплаты и налогов позволяет произвольным образом настроить порядок отражения этих сумм в затратах
                предприятия, получить аналитическую отчетность по итогам расчетов, а также автоматически передать эти данные в типовые конфигурации
                бухгалтерского учета – программы "1С:Бухгалтерия 8 для Казахстана", "1С:Управление торговым предприятием 8 для Казахстана". Пользователям
                предоставляется возможность задавать отражение в учете как для конкретного начисления (например, материальной помощи), так и всего основного
                заработка сотрудника одним или несколькими способами отражения. При большом количестве сотрудников полезной будет возможность задать способ
                отражения в учете заработка сотрудников всего подразделения в целом. Реализована возможность управления использованием статей затрат при
                отражении в учете налогов с ФОТ.
            </p>
            <p>
                <h4>Регламентированная отчетность организаций</h4>
            </p>
            <p>В конфигурации автоматически формируются регламентированные отчеты для представления в налоговые органы и органы по статистике:</p>
            <ul>
                <li>Декларации по индивидуальному подоходному налогу и социальному налогу, упрощённая декларация для субьектов малого бизнеса;</li>
                <li>Государственная статистическая отчетность (статистика труда и занятости населения).</li>
            </ul>
            <p>Предусмотрена выгрузка регламентированной отчетности для передачи в органы налоговой службы в электронном виде.</p>
            <p>
                <h4>Сервисные возможности</h4>
            </p>
            <p>
                <h4>Версионирование объектов</h4>
            </p>
            <p>
                Подсистема предназначена для учета истории изменений объектов (кто, когда и что изменил). Позволяет получать отчеты по версиям документов или
                справочников.
            </p>
            <p>
                <h4>Автоматическое выполнение работ по расписанию</h4>
            </p>
            <p>Предоставляет возможность составлять расписание для автоматического выполнения отдельных операций.</p>
            <p>
                <h4>Управление регламентными заданиями</h4>
            </p>
            <p>
                Подсистема позволяет редактировать состав и расписание регламентных заданий, просматривать историю выполнения регламентных и фоновых заданий, а
                также анализировать ошибки при их выполнении.
            </p>
            <p>
                <h4>Создание внешних печатных форм в Microsoft Word и Open Office</h4>
            </p>
            <p>
                Подсистема предназначена для формирования произвольных печатных форм объектов на основе табличных макетов (формат MXL) или макетов офисных
                документов в форматах Microsoft Word и OpenOffice.org Writer. Механика может быть использована для создания шаблонов документов и настройки
                правил их заполнения по внутренним стандартам компании.
            </p>
            <p>
                <h4>Функции и варианты отчетов</h4>
            </p>
            <p>Подсистемы выполняют следующие функции:</p>
            <ul>
                <li>организация хранения и доступа к вариантам отчетов пользователей;</li>
                <li>организация быстрого доступа через интерфейс подсистем к вариантам отчетов;</li>
                <li>создание элементов управления быстрыми настройками пользователя на форме отчета.</li>
            </ul>
           
            
        </div>
    )
}

export { ID2 }
